export enum APP {
  SET_APP_MENU_STATUS = 'SET_APP_MENU_STATUS',
  SET_APP_OPEN_TAGS = 'SET_APP_OPEN_TAGS',
  SET_APP_MENU_ROUTES = 'SET_APP_MENU_ROUTES',
}

export enum USER {
  SET_USER_AUTH = 'SET_USER_AUTH',
  SET_USER_MENU_ROUTES = 'SET_USER_MENU_ROUTES',
  SET_USER_MENUS = 'SET_USER_MENUS',
  SET_USER_BTNS = 'SET_USER_BTNS',
  SET_USER_STAIR_MENUS = 'SET_USER_STAIR_MENUS',
}

export enum ORG {
  SET_ORG_CONSUME_SHOW = 'SET_ORG_CONSUME_SHOW',
  SET_ORG_INFO_STATUS = 'SET_ORG_INFO_STATUS',
  SET_ORG_CONSUME_STATUS = 'SET_ORG_CONSUME_STATUS',
  SET_ORG_COST_STATUS = 'SET_ORG_COST_STATUS',
  SET_ORG_RECHARGE_STATUS = 'SET_ORG_RECHARGE_STATUS',
  SET_ORG_BTN_COMPENT = 'SET_ORG_BTN_COMPENT',
  SET_ORG_COMPENT_REFRESH = 'SET_ORG_COMPENT_REFRESH',
}

export enum COURSE {
  SET_COURSE_CHAPTER_CID = 'SET_COURSE_CHAPTER_CID',
}

export enum ASSET {
  SET_ASSET_MANAGE_REMOVE_DATA = 'SET_ASSET_MANAGE_REMOVE_DATA',
  SET_ASSET_MANAGE_REMOVE_FLAG = 'SET_ASSET_MANAGE_REMOVE_FLAG',
  SET_ASSET_CATEGORY_LIST_FLAG = 'SET_ASSET_CATEGORY_LIST_FLAG'
}

export enum QUESTIONS {
  SET_ASSET_MANAGE_REMOVE_DATA = 'SET_ASSET_MANAGE_REMOVE_DATA',
  SET_ASSET_MANAGE_REMOVE_FLAG = 'SET_ASSET_MANAGE_REMOVE_FLAG',
}

export default {
  APP,
  USER,
  ORG,
  COURSE,
  ASSET,
  QUESTIONS,
};
